var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNamebadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10040_65605",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 14,
    width: 83,
    height: 55
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 68.5742H82.5V14.3484H0.5V68.5742Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10040_65605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.2489 63.7122V19.0008C82.2489 16.4452 80.1466 14.367 77.3445 14.367H41.3831V68.5742H77.3445C80.1466 68.5742 82.2489 66.4959 82.2489 63.7122Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0085 53.74H46.7498V49.8122H75.0085V53.74ZM65.4349 58.1444H46.7498V62.3203H65.4349V58.1444Z",
    fill: "black",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4029 14.367C2.83566 14.367 0.5 16.4452 0.5 19.0008V63.7122C0.5 66.4959 2.83566 68.5742 5.4029 68.5742H41.3831V14.367H5.4029Z",
    fill: "#021F42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1684 29.8878C30.1684 34.2922 26.6744 37.9907 22.0029 37.9907C17.5636 37.9907 13.8186 34.2922 13.8186 29.8878C13.8186 25.254 17.5636 21.7841 22.0029 21.7841C26.6744 21.7841 30.1684 25.254 30.1684 29.8878ZM36.0173 60.9285C36.9438 60.9285 37.4066 60.242 37.4066 59.5369V47.2574C37.4066 44.0161 34.8398 41.4613 31.5773 41.4613H12.6607C9.37929 41.4613 6.58032 44.0161 6.58032 47.2574V59.5369C6.58032 60.242 7.2752 60.9285 7.98938 60.9285H36.0173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.83 25.9404C52.1154 25.9404 51.6526 26.1698 51.1889 26.8749L47.4447 30.3448C46.5175 31.2793 46.5175 32.9003 47.4447 33.8155L57.5007 43.7874L67.5387 33.8155C68.4652 32.9003 68.4652 31.2793 67.5387 30.3448L64.0447 26.8749C63.5623 26.1698 62.8673 25.9404 62.1722 25.9404C61.7094 25.9404 60.9947 26.1698 60.5319 26.8749L57.5007 29.659L54.7018 26.8749C54.2193 26.1698 53.5251 25.9404 52.83 25.9404Z",
    fill: "#CB2027"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamebadge);
export default __webpack_public_path__ + "static/media/namebadge.f921a6f79201a0a20a3736449b2745a9.svg";
export { ForwardRef as ReactComponent };